import { css } from "@emotion/react";
import { kitText, kitShadow } from "../../styles";

const flexCenter = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const baseContainer = css`
  position: relative;
  border: 1px solid var(--color-border-secondary);
  border-radius: var(--border-radii-md);
  background: var(--color-background-primary);
  transition:
    border-color 200ms,
    box-shadow 200ms;
`;

export const styles = {
  fileContainer: css`
    ${baseContainer}
    display: flex;
    align-items: center;
    gap: var(--spacing-8);
    width: fit-content;
    max-width: 224px;
    padding: var(--spacing-4);
  `,

  imageContainer: css`
    ${baseContainer}
    ${flexCenter}
    width: 58px;
    height: 58px;
    overflow: hidden;
    border-radius: var(--border-radii-md);
    padding: 0;
  `,

  errorState: css`
    border-color: var(--color-border-danger);
    background: var(--color-background-primary);

    &:hover {
      border-color: var(--color-border-danger);
      box-shadow: none;
    }
  `,

  actions: css`
    position: absolute;
    top: var(--spacing-4);
    right: var(--spacing-4);
    gap: var(--spacing-4);
    opacity: 0;
    pointer-events: none;
    transition: opacity 200ms;

    .kit-FileCard:hover &,
    .kit-FileCard:focus-within & {
      opacity: 1;
      pointer-events: auto;
    }
  `,

  clickable: css`
    cursor: pointer;

    &:hover {
      border-color: var(--color-splash-primary);
      ${kitShadow.small}
    }

    &:focus-visible {
      outline: 2px solid var(--color-splash-primary);
      outline-offset: 2px;
    }
  `,

  fileContent: css`
    display: flex;
    align-items: center;
    gap: var(--spacing-8);
    flex: 1;
    min-width: 0;
    padding-right: var(--spacing-24);
  `,

  iconContainer: css`
    ${flexCenter}
    flex-shrink: 0;
    width: 48px;
    height: 48px;
    border-radius: var(--border-radii-base);
    background: var(--color-border-secondary);
  `,

  textContainer: css`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2);
    flex: 1 0 0;
    min-width: 0;
  `,

  fileName: css`
    font-family: var(--font-family-body);
    font-size: var(--font-size-12);
    line-height: var(--spacing-16);
    font-weight: var(--font-weight-normal);
    ${kitText.color.primary}
    display: flex;
    overflow: hidden;
    white-space: nowrap;
  `,

  errorText: css`
    font-family: var(--font-family-body);
    font-size: var(--font-size-12);
    line-height: var(--spacing-16);
    font-weight: var(--font-weight-normal);
    color: var(--color-danger);
  `,

  closeButton: css`
    ${flexCenter}
    position: absolute;
    top: var(--spacing-4);
    right: var(--spacing-4);
    width: var(--spacing-20);
    height: var(--spacing-20);
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    z-index: 3;
    transition: opacity 200ms;

    &:hover {
      opacity: 0.7;
    }

    &:focus-visible {
      outline: 2px solid var(--color-splash-primary);
      outline-offset: 1px;
    }
  `,

  imageThumbnail: css`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: var(--border-radii-base);
  `,

  imagePlaceholder: css`
    ${flexCenter}
    width: 100%;
    height: 100%;
    background: var(--color-border-secondary);
    color: var(--color-secondary);
  `,

  imageError: css`
    ${flexCenter}
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: var(--color-border-secondary);
    color: var(--color-danger);
  `,

  hidden: css`
    display: none;
  `
};
